import { useEffect, useState } from "react";
import {
  ModalAcceptCancel as ModalComponent,
  //@ts-ignore
} from "@viuti/recursos";
import {
  ACCESS_DENIED,
  FEATURE_LIMITED_REACHED,
  MODAL_TYPE_T,
  PLAN_LIMIT_REACHED,
} from "../../models/access";
import { IAccountInfo } from "../../models/interfaces/account";
import { getAccessModalTitle } from "./utils/getAccessModalTitle";
import useAccessModalChildren from "./hooks/useAccessModalChildren";

const ModalAccessDenied = () => {
  const [isAccessModalVisible, setIsAccessModalVisible] = useState(false);
  const [requiredAccess, setRequiredAccess] = useState(null);
  const [modalType, setModalType] = useState<MODAL_TYPE_T>();
  const [fetchResponse, setFetchResponse] = useState<IResponse>(null);
  const [featureCounter, setFeatureCounter] = useState<number>(0);
  const [featureType, setFeatureType] = useState<string>("");

  const accountInfo: IAccountInfo = JSON.parse(
    localStorage.getItem("account_info")
  );

  useEffect(() => {
    const updateModalType = (type: MODAL_TYPE_T) => {
      setIsAccessModalVisible(true);
      setModalType(type);
    };

    const handleAccessDenied = (event) => {
      const { accessId } = (event as CustomEvent).detail;
      setRequiredAccess(accessId);
      updateModalType(ACCESS_DENIED);
    };

    const handlePlanDenied = (event) => {
      const { accessId } = (event as CustomEvent).detail;
      setRequiredAccess(accessId);
      updateModalType(PLAN_LIMIT_REACHED);
    };

    const handleFeatureLimited = (event) => {
      const { type, counter, message } = (event as CustomEvent).detail;
      setFeatureCounter(counter);
      setFeatureType(type);
      updateModalType(FEATURE_LIMITED_REACHED);
    };

    window.addEventListener("access-denied", handleAccessDenied);
    window.addEventListener("plan-denied", handlePlanDenied);
    window.addEventListener("feature-limited", handleFeatureLimited);

    return () => {
      window.removeEventListener("access-denied", handleAccessDenied);
      window.removeEventListener("plan-denied", handlePlanDenied);
      window.removeEventListener("feature-limited", handleFeatureLimited);
    };
  }, []);

  let modalProps = null;
  switch (modalType) {
    case ACCESS_DENIED:
      modalProps = {
        accountInfo,
        requiredAccess,
        emailSentResponse: fetchResponse,
        setEmailSentResponse: setFetchResponse,
      };
      break;
    case PLAN_LIMIT_REACHED:
      modalProps = { accountInfo };
      break;
    case FEATURE_LIMITED_REACHED:
      modalProps = {
        accountInfo,
        type: featureType,
        counter: featureCounter,
        message:
          "Has alcanzado el límite de cajas permitidas en tu plan actual",
      };
      break;
    default:
      modalProps = {};
      break;
  }

  const handleCloseModal = () => {
    setIsAccessModalVisible(false);
    setFetchResponse(null);
  };

  const modalChildren = useAccessModalChildren(
    modalType,
    modalProps,
    handleCloseModal
  );

  const showButtonClose = () =>
    modalType === FEATURE_LIMITED_REACHED ? false : true;

  return (
    <ModalComponent
      title={getAccessModalTitle(modalType)}
      visibility={{
        isVisible: isAccessModalVisible,
        isSetVisible: setIsAccessModalVisible,
      }}
      actionButtonClose={handleCloseModal}
      showButtons={{
        showButtonOne: false,
        showButtonTwo: false,
        showButtonClose: showButtonClose(),
      }}
      zIndex={1002}
    >
      {modalChildren}
    </ModalComponent>
  );
};

export default ModalAccessDenied;
